"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomBase64 = void 0;
const crypto_1 = require("crypto");
exports.randomBase64 = (length) => crypto_1.randomBytes(Math.ceil((length * 3) / 4))
    .toString("base64")
    .slice(0, length)
    .replace(/\+/g, "0")
    .replace(/\//g, "0");
//# sourceMappingURL=random-base64.js.map